import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { Row, Col, Card, CardBody, Table, Badge, Input } from "reactstrap";
import dayjs from "dayjs";
import { User, Calendar, DollarSign, Search, Trash2 } from "lucide-react";
import { toast } from "react-toastify";

const DriverSalaryMasterList = () => {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const limit = 20;

    const loadSalaries = async () => {
        dispatch(loadingTrue());
        const offset = (page - 1) * limit;
        const res = await Handler({
            method: "get",
            url: `/driver/sal_details.php?limit=${limit}&offset=${offset}&search=${search}`
        });

        console.log("Actual API Response:", res); // Debugging-ku ithu romba mukkiyam

        if (res && res.success) {
            setData(res.data || []);
            setTotal(res.total_count || 0);
        } else {
            // Ippo check pannunga, error message enna varuthunu
            console.error("Fetch failed:", res?.message);
            toast.error(res?.message || "Failed to load data");
        }
        dispatch(loadingFalse());
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this salary record?")) return;
        dispatch(loadingTrue());
        const res = await Handler({
            method: "post",
            url: "/invoice/driver_salary.php",
            data: { action: "delete_salary", id }
        });
        if (res?.success) {
            toast.success("Deleted successfully");
            loadSalaries();
        }
        dispatch(loadingFalse());
    };

    useEffect(() => {
        loadSalaries();
    }, [page, search]);

    return (
        <div className="page-wrapper p-4 animate-fade-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fw-bold text-dark mb-0">Driver Salary Master List</h4>
                <div className="search-box position-relative" style={{ width: "300px" }}>
                    <Search className="position-absolute top-50 translate-middle-y ms-3 text-muted" size={18} />
                    <Input
                        className="ps-5 rounded-pill border-0 shadow-sm"
                        placeholder="Search driver or invoice..."
                        value={search}
                        onChange={(e) => { setPage(1); setSearch(e.target.value); }}
                    />
                </div>
            </div>

            <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                <div className="table-responsive">
                    <Table hover className="mb-0 align-middle modern-list">
                        <thead className="bg-light">
                            <tr>
                                <th className="ps-4">ID</th>
                                <th>Driver Details</th>
                                <th className="text-center">Invoice ID</th>
                                <th className="text-center">Salary Amount</th>
                                <th className="text-center">Salary Date</th>
                                <th>Remarks</th>
                                {/* <th className="text-end pe-4">Actions</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? data.map((item) => (
                                <tr key={item.id}>
                                    <td className="ps-4 text-muted small">#{item.id}</td>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="avatar-circle bg-soft-info text-info">
                                                {item.driver_name?.charAt(0).toUpperCase()}
                                            </div>
                                            <div>
                                                <span className="fw-bold d-block">{item.driver_name}</span>
                                                <small className="text-muted">Driver ID: {item.driver_id}</small>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <Badge color="light" className="text-dark border px-3">INV-{item.invoice_id}</Badge>
                                    </td>
                                    <td className="text-center">
                                        <span className="fw-bold text-success">$ {parseFloat(item.salary_amount).toLocaleString()}</span>
                                    </td>
                                    <td className="text-center small">
                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                            <Calendar size={14} className="text-muted" />
                                            {dayjs(item.salary_date).format("DD-MM-YYYY")}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-truncate small text-muted" style={{ maxWidth: "150px" }} title={item.remarks}>
                                            {item.remarks || "---"}
                                        </div>
                                    </td>
                                    {/* <td className="text-end pe-4">
                                        <button className="btn btn-sm text-danger border-0" onClick={() => handleDelete(item.id)}>
                                            <Trash2 size={18} />
                                        </button>
                                    </td> */}
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="7" className="text-center py-5 text-muted">No salary records found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card>

            <div className="mt-4 d-flex justify-content-center">
                <Pagination
                    page={page}
                    total={total}
                    limit={limit}
                    onPrev={() => setPage(p => Math.max(1, p - 1))}
                    onNext={() => setPage(p => p + 1)}
                />
            </div>

            <style>{`
                .modern-list thead th { font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; padding: 15px 10px; color: #6b7280; border-bottom: 2px solid #f3f4f6; }
                .modern-list tbody td { padding: 15px 10px; font-size: 13.5px; border-bottom: 1px solid #f9fafb; }
                .avatar-circle { width: 35px; height: 35px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; background-color: #e0f2fe; }
                .bg-soft-info { background-color: #e0f2fe !important; }
                .animate-fade-in { animation: fadeIn 0.4s ease-in; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
};

export default DriverSalaryMasterList;